<template>
  <b-container fluid id="app">
    <!-- header -->
    <b-row>
      <b-col cols="2" class="d-none d-lg-block">
        <a href="https://heavens-above.com">
          <img src="images/ha-logo.svg" style="width: 170px" />
        </a>
      </b-col>
      <b-col class="col-12 col-lg-10">
        <Adsense
          data-ad-client="ca-pub-5668297076217155"
          data-ad-slot="2236698410"
          data-ad-format="horizontal"
          ins-class="adslot_header"
        ></Adsense>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-navbar toggleable="lg" type="dark" class="ha-navbar">
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <b-navbar-brand href="https://heavens-above.com" class="d-xl-none d-lg-none">Heavens-Above</b-navbar-brand>

          <!-- Left aligned nav items -->
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="h5">
              <b-nav-item-dropdown v-bind:text="strings['satellites']">
                <b-dropdown-item to="/livesky">{{strings['live.sky.view']}}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item
                  href="https://heavens-above.com/Starlink.aspx"
                >{{strings['starlink.aspx.title']}}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item
                  href="https://heavens-above.com/StarlinkLaunchPasses.aspx"
                >{{strings['starlinklaunchpasses.title']}}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item href="https://heavens-above.com/PassSummary.aspx?satid=25544">ISS</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item-dropdown v-bind:text="strings['astronomy']">
                <b-dropdown-item
                  href="https://heavens-above.com/SkyChart2.aspx"
                >{{strings['/skychart2.aspx.title']}}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item href="https://heavens-above.com/Sun.aspx">{{strings['sun']}}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item href="https://heavens-above.com/Moon.aspx">{{strings['moon']}}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item
                  href="https://heavens-above.com/PlanetSummary.aspx"
                >{{strings['planets']}}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item
                  href="https://heavens-above.com/Comets.aspx"
                >{{strings['comets.page.title']}}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item
                  href="https://heavens-above.com/Asteroids.aspx"
                >{{strings['asteroids']}}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <!-- <b-dropdown-item to="/constellations">{{strings['constellations']}}</b-dropdown-item> -->
                <!-- <b-dropdown-divider></b-dropdown-divider> -->
                <b-dropdown-item
                  href="https://heavens-above.com/SolarEclipses.aspx"
                >{{strings['solar.eclipses']}}</b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>

          <!-- Right aligned nav items -->
            <b-nav-text class="clock d-none d-md-block" id="clock">{{clockText}}</b-nav-text>
            <b-nav-form>
              <b-button
                v-b-modal.modal-settings
                class="settings"
                v-b-tooltip.hover
                v-bind:title="strings['settings']"
              >
                <b-icon icon="gear-fill" aria-hidden="true"></b-icon>
              </b-button>
              <b-button
                @click="fullscreen"
                class="settings"
                style="margin-left:5px"
                v-b-tooltip.hover
                v-bind:title="strings['fullscreen']"
              >
                <b-icon icon="arrows-fullscreen" aria-hidden="true"></b-icon>
              </b-button>
            </b-nav-form>
            <!-- <b-dropdown id="dropdown-form" ref="dropdown" class="settings ml-1" right no-caret>
                <template v-slot:button-content>
                  <b-icon icon="person-fill" aria-hidden="true"></b-icon>
                </template>
                <b-dropdown-item href="https://heavens-above.com/SelectLocation.aspx">Location</b-dropdown-item>
                <b-dropdown-item href="#">Language</b-dropdown-item>
            </b-dropdown>-->
        </b-navbar>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="content" id="content">
            <router-view></router-view>
        </div>
      </b-col>
    </b-row>
    <router-view name="settings"></router-view>
    <b-tooltip target="clock" v-bind:title="strings['local.time']"></b-tooltip>
  </b-container>
</template>

<script>
//import LiveSkyPage from "./components/LiveSkyPage.vue";
//import LiveSkyPageSettings from "./components/LiveSkyPageSettings.vue";
//import TimeSelector from "./components/TimeSelector.vue";
//import Adsense from "./components/AdSense.vue";
import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import moment from "moment";
import fscreen from "fscreen";
import * as HA from "@h-a/astrolib";
import store from "./store";
import { mapState } from "vuex";

Vue.use(Vuex);
Vue.use(VueRouter);

export default {
  name: "App",
  store,
  components: {
    //LiveSkyPage,
    //LiveSkyPageSettings
  },

  computed: {
    ...mapState([
      "utc",
      "location",
      "culture",
      "strings",
      "satellites",
      "settings"
    ]),
    clockText: function() {
      return moment(this.utc).format("HH:mm:ss");
    }
  },
  data: function() {
    return {
      startupTime: new Date().getTime(),
      strDate: null,
      strTime: null
    };
  },
  created: function() {
    let lat = parseFloat(this.getQueryVariable("lat"));
    let lng = parseFloat(this.getQueryVariable("lng"));
    let loc = this.getQueryVariable("loc");
    let cul = this.getQueryVariable("cul");
    let gs = new HA.GroundStation(lat, lng, 0);
    gs.name = loc;
    store.commit("setLocation", gs);
    if (cul) store.commit("setCulture", cul);

    // initialise store
    store.dispatch("initialise");
  },
  mounted: function() {
    // (window.adsbygoogle = window.adsbygoogle || []).push({});

    // call the layout function of the page here, because the page content component is resized during the app component mount
    if (this.$refs.pageContent)
      if (this.$refs.pageContent.layout) this.$refs.pageContent.layout();
  },
  methods: {
    fullscreen: function() {
      // fullscreen the contents
      fscreen.onfullscreenchange = () => {
        this.isFullscreen = fscreen.fullscreenElement !== null;
        this.render();
      };
      if (this.isFullscreen) fscreen.exitFullscreen();
      else {
        let elemContent = document.getElementById("content");
        fscreen.requestFullscreen(elemContent);
      }
    },
    getQueryVariable: function(variable) {
      let query = window.location.search.substring(1);
      let vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 15px;
  border-style: none;
  margin-left: auto;
  margin-right: auto;
}
.controls {
  padding-top: 0px;
  background-color: lightgray;
  text-align: left;
}
.ha-navbar {
  background-color: #000;
  padding: 5px;
  margin-top: 10px;
}
.clock {
  padding-right: 10px;
}
.content {
  height: 800px;
  padding: 5px;
}
.adslot_header {
  width: 320px;
  height: 100px;
  margin: auto;
}
@media (min-width: 500px) {
  .adslot_header {
    width: 468px;
    height: 60px;
  }
}
@media (min-width: 800px) {
  .adslot_header {
    width: 728px;
    height: 90px;
  }
}
</style>